import * as React from 'react';

import { UitkIcon } from 'uitk-react-icons';

interface WhatsAroundListItemProps {
  accessibleCategory?: string;
  category?: string;
  dtClassName?: string;
  iconId?: string;
  id?: string;
  liClassName?: string;
  liContent: string;
}

export const WhatsAroundListItem: React.FunctionComponent<WhatsAroundListItemProps> = ({
  accessibleCategory,
  category,
  dtClassName,
  iconId,
  id,
  liClassName,
  liContent
}) => {
  if (!(liContent && category)) {
    return null;
  }

  return (
    <li className={liClassName} key={id}>
      <UitkIcon id={iconId} name={category} title={accessibleCategory ? accessibleCategory : null} />
      <dl className="uitk-grid all-cell-1-2">
        <dt className={`${dtClassName}__list-item-content uitk-cell all-cell-fill all-r-padding-two`}>{liContent}</dt>
        <dd />
      </dl>
    </li>
  );
};
